// FETCH ALL PROPERTIES FROM USER DETAILS
export const FETCH_USER_DETAILS_REQUEST = 'FETCH_USER_DETAILS_REQUEST';
export const FETCH_USER_DETAILS_SUCCESS = 'FETCH_USER_DETAILS_SUCCESS';
export const FETCH_USER_DETAILS_FAILURE = 'FETCH_USER_DETAILS_FAILURE';

// CREATE PROPERTIES FOR USER DETAILS
export const CREATE_USER_DETAILS_REQUEST = 'CREATE_USER_DETAILS_REQUEST';
export const CREATE_USER_DETAILS_SUCCESS = 'CREATE_USER_DETAILS_SUCCESS';
export const CREATE_USER_DETAILS_FAILURE = 'CREATE_USER_DETAILS_FAILURE';

// UPDATE PROPERTIES FOR USER DETAILS
export const UPDATE_USER_DETAILS_REQUEST = 'UPDATE_USER_DETAILS_REQUEST';
export const UPDATE_USER_DETAILS_SUCCESS = 'UPDATE_USER_DETAILS_SUCCESS';
export const UPDATE_USER_DETAILS_FAILURE = 'UPDATE_USER_DETAILS_FAILURE';

// FETCH SINGLE STATE
export const FETCH_SINGLE_USER_DETAILS_REQUEST = 'FETCH_SINGLE_USER_DETAILS_REQUEST';
export const FETCH_SINGLE_USER_DETAILS_SUCCESS = 'FETCH_SINGLE_USER_DETAILS_SUCCESS';
export const FETCH_SINGLE_USER_DETAILS_FAILURE = 'FETCH_SINGLE_USER_DETAILS_FAILURE';

// DELETE PROPERTIES FOR USER DETAILS
export const DELETE_USER_DETAILS_REQUEST = 'DELETE_USER_DETAILS_REQUEST';
export const DELETE_USER_DETAILS_SUCCESS = 'DELETE_USER_DETAILS_SUCCESS';
export const DELETE_USER_DETAILS_FAILURE = 'DELETE_USER_DETAILS_FAILURE';

export const RESET_USER_DETAILS_INFO = 'RESET_USER_DETAILS_INFO';

export const CREATE_USER_DETAILS_FORM = 'CREATE_USER_DETAILS_FORM';

export const UPDATE_USER_DETAILS_FORM = 'UPDATE_USER_DETAILS_FORM';
